<h2>{{ 'SPACING.PADDING' | translate }}</h2>
<div class="d-flex flex-column">
  @for (padding of paddings; track padding) {
    <strong>p-{{ padding }}</strong>
    <div #el class="outer p-{{ padding }}">
      <div class="inner">
        {{ getPadding(el) }}
      </div>
    </div>
  }
</div>

<h2>{{ 'SPACING.MARGIN' | translate }}</h2>
<div class="d-flex flex-column">
  @for (margin of margins; track margin) {
    <strong>m-{{ margin }}</strong>
    <div class="outer">
      <div #el class="inner m-{{ margin }}">
        {{ getMargin(el) }}
      </div>
    </div>
  }
</div>

<h2>{{ 'SPACING.GAP' | translate }}</h2>
<div class="d-flex flex-column">
  @for (gap of gaps; track gap) {
    <strong>hgap-{{ gap }} ({{ getGap(el) }})</strong>
    <div #el class="outer hgap-{{ gap }}">
      <div class="inner"></div>
      <div class="inner"></div>
      <div class="inner"></div>
      <div class="inner"></div>
      <div class="inner"></div>
    </div>
  }
</div>

<div class="d-flex flex-row justify-content-between">
  @for (gap of gaps; track gap) {
    <div class="d-flex flex-column">
      <strong>gap-{{ gap }} ({{ getGap(el) }})</strong>
      <div #el class="outer gap-{{ gap }}">
        <div class="inner"></div>
        <div class="inner"></div>
      </div>
    </div>
  }
</div>
